import { getPhrases } from './getPhrases';
import { getDictionary } from './getDictionary';
import { checkLocaleIsValid } from './locale/language';
import { config } from '@/config';
import { incrementGlobalErrorCount } from './global-error-counter/global-error-counter';
import { DefaultPageProps, IPhrases } from '@/types/types/page/pages';

interface GetPageInitialDataOptions {
    phraseIds?: number | number[];
    exclude?: Array<'dictionary' | 'phrases'>;
    cacheType?: 'nextRevalidate' | 'custom';
}
export interface InitialPageData {
    phrases?: IPhrases;
    dictionary: DefaultPageProps['dictionary'];
}

const BUILD_ERROR_LIMIT = 1;
const IS_BUILD_STAGE = process.env.IS_BUILD_STAGE === 'true';

export const getPageInitialData = async (
    tagIds: number | number[],
    locale = 'en-INT',
    path: string,
    options: GetPageInitialDataOptions = {
        phraseIds: undefined,
        exclude: [],
    },
): Promise<InitialPageData> => {
    try {
        const validLocale = checkLocaleIsValid(locale) ? locale : config.defaultLocale;
        const { phraseIds, cacheType, exclude } = options;

        const phrases = !exclude?.includes('phrases')
            ? await getPhrases({
                  tagIds,
                  locale: validLocale,
                  path,
                  phraseIds,
                  cacheType,
              })
            : undefined;

        const dictionary = await getDictionary();

        return {
            phrases,
            dictionary,
        };
    } catch (err) {
        console.error(err);
        const errorCount = incrementGlobalErrorCount();

        if (IS_BUILD_STAGE && errorCount >= BUILD_ERROR_LIMIT) {
            console.error(
                `Stopping build: ${errorCount} error${errorCount > 1 ? 's' : ''} (limit: ${BUILD_ERROR_LIMIT})`,
            );
            return process.exit(1);
        } else {
            throw err;
        }
    }
};
